import APISearchResult from './APISearchResult';
import {columnsLocal, columnsForeign} from './TableColumns';
import APISearchQuery from './APISearchQuery';

export   {
    columnsLocal, columnsForeign,
    APISearchResult,
    APISearchQuery
}


// WEBPACK FOOTER //
// src/components/SearchResult/index.js